import React from 'react';
import { ShieldIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-16 md:py-20 px-6 bg-beige" data-id="element-83">
      <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-84">
        <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-8 shadow-sm border border-dark/5" data-id="element-85">
          <ShieldIcon className="w-10 h-10 text-warmgold" strokeWidth={1.5} data-id="element-86" />
        </div>
        <h2 className="font-playfair text-3xl md:text-4xl text-dark mb-6" data-id="element-87">
          Garantía de 7 días
        </h2>
        <p className="text-dark/70 font-light text-lg leading-relaxed max-w-xl" data-id="element-88">
          Tu paz mental es nuestra prioridad. Si sientes que este material no
          resuena con tu historia o no te aporta el valor que esperabas, te
          devolvemos tu inversión sin preguntas.
        </p>
      </div>
    </section>;
}